import React from 'react';

export default function PocketCastIcon(props) {
    return (

        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M24 12.5C24 18.8514 18.8514 24 12.5 24S1 18.8514 1 12.5 6.1486 1 12.5 1 24 6.1486 24 12.5" fill="#f43e37" fillOpacity={0} /><path d="M3.5556 12.6065c0-4.9987 4.0522-9.051 9.051-9.051s9.05 4.0522 9.05 9.051h-2.2628c0-3.75-3.0392-6.7882-6.7882-6.7882s-6.7882 3.0392-6.7882 6.7882 3.0392 6.7882 6.7882 6.7882v2.2628c-4.9987 0-9.051-4.0523-9.051-9.05zm9.051 5.4306c-2.9992 0-5.4305-2.4314-5.4305-5.4306S9.6073 7.176 12.6065 7.176s5.4306 2.4313 5.4306 5.4305h-1.9748c0-1.9086-1.5472-3.4558-3.4558-3.4558s-3.4558 1.5472-3.4558 3.4558 1.5472 3.4558 3.4558 3.4558v1.9748z" /></svg>

    );
}